import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  constructor(public http: HttpTestService, public session: sessionServices, public router: Router) { }

  ngOnInit() {
    this.checkFromUrlIfCalledFromPaymentJSP();
   // this.checkFromUrlIfCalledFromPaymentJSP1();
  }
  
  checkFromUrlIfCalledFromPaymentJSP = function(){
    var URL:any = window.location.href;
		if(URL.includes("?paymentprocessingstatus=")){
			//var tokken = URL.split("=");
     // alert("tokken :" + URL);
      var res = URL.indexOf("?");
      var message = URL.substring(res + 1);
     // alert("Dashboard::message: "+message);
	   	this.router.navigate(['/paymentstatusmsg', message],{ skipLocationChange: true });
		}
		
	}

  checkFromUrlIfCalledFromPaymentJSP1 = function(){
		var URL:any = window.location.href;
		if(URL.includes("?paymentstatusmsg=")){
			//var tokken = URL.split("=");
     // alert("tokken :" + URL);
      var res = URL.indexOf("=");
      var message = URL.substring(res+1);
      // alert("URL: "+message);
	   	this.router.navigate(['/paymentstatus',message],{ skipLocationChange: true });
		}
		
	}




}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/dashboard/dashboard.component.ts